export class PickActions {
    static ActionConfirm: string = "PICK_CONFIRM";
    static ActionBack: string = "PICK_BACK_TO_GAME";

    static ActionRespinMultipliers: string = "RESPIN_MULTIPLIERS";
    static ActionRespinFreespins: string = "RESPIN_FREESPINS";
    static ActionRespinLevels: string = "RESPIN_LEVELS";
}

export class PickOptions {
    static Respin: string = "RESPIN";
    static Empty: string = "EMPTY";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Actions/PickActions.ts
 **/